import actions from "./actions";

const {
    FETCH_TEACHER_UNSEEN_EMAILS,
    FETCH_STUDENT_UNSEEN_EMAILS,
    FETCH_UNSEEN_COMMENTS,
    FETCH_UNSEEN_MESSAGES,
    FETCH_UNSEEN_CV,
    FETCH_UNSEEN_OFFICIAL_EMAILS,
    FETCH_UNSEEN_PERMISSION_UPDATE,
    FETCH_UNSEEN_TALENT_CV,
    FETCH_CLASS_TEACHER_ZOOM_UNSEEN_EMAILS
} = actions;

const initState = {
    teacherUnseenEmails: {
        data: [],
    },
    studentUnseenEmails: {
        data: [],
    },
    classTeacherZoomUnseenEmails: {
        data: [],
    },
    unseenComments: {
        data: [],
    },
    unseenMessages: {
        data: [],
    },
    unseenCVs: {
        data: [],
    },
    unseenTalentCVs: {
        data: [],
    },
    unseenOfficialEmails: {
        data: [],
    },
    unseenPermissionUpdate: {
        data: [],
    },
};

const NotificationReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_TEACHER_UNSEEN_EMAILS:
            return {
                ...state,
                teacherUnseenEmails: data
            };
        case FETCH_STUDENT_UNSEEN_EMAILS:
            return {
                ...state,
                studentUnseenEmails: data
            };
        case FETCH_CLASS_TEACHER_ZOOM_UNSEEN_EMAILS:
            return {
                ...state,
                classTeacherZoomUnseenEmails: data
            };
        case FETCH_UNSEEN_COMMENTS:
            return {
                ...state,
                unseenComments: data
            };
        case FETCH_UNSEEN_MESSAGES:
            return {
                ...state,
                unseenMessages: data
            };
        case FETCH_UNSEEN_CV:
            return {
                ...state,
                unseenCVs: data
            };
        case FETCH_UNSEEN_TALENT_CV:
            return {
                ...state,
                unseenTalentCVs: data
            };
        case FETCH_UNSEEN_OFFICIAL_EMAILS:
            return {
                ...state,
                unseenOfficialEmails: data
            };
        case FETCH_UNSEEN_PERMISSION_UPDATE:
            return {
                ...state,
                unseenPermissionUpdate: data
            };
        default:
            return state;
    }
};

export default NotificationReducer;
